// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","funeral-home-amenities":"funeral-home-amenities","funeral-home-amenities__header":"funeral-home-amenities__header","funeral-home-amenities__list":"funeral-home-amenities__list","funeral-home-amenities__item":"funeral-home-amenities__item","funeral-home-amenities__name":"funeral-home-amenities__name","funeral-home-amenities__svg":"funeral-home-amenities__svg"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Tabs/AboutUs/Amenities/css/Amenities.styl
// module id = 586
// module chunks = 0